import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, useDisclosure } from "@chakra-ui/react";
import { FC, useRef } from "react";

interface ConfirmDialogProps {
    title: string;
    message: string;
    colorScheme: string;
    buttonLabel: string;
    onSubmit: any;
    onClose: any;
    isLoading: boolean;
};

const ConfirmDialog: FC<ConfirmDialogProps> = ({ title, message, colorScheme, buttonLabel, onSubmit, onClose, isLoading }) => {
    const cancelRef = useRef<any>();

    return (
        <>
            <AlertDialog
                isOpen={true}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {title}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {message}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose} variant={'outline'}>
                                Batal
                            </Button>
                            <Button variant={'solid'} colorScheme={colorScheme} onClick={onSubmit} ml={3} isLoading={isLoading}>
                                {buttonLabel}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
};

export default ConfirmDialog;